import request from '@/utils/request';

export function getSysNoticeList(query) {
  return request({
    url: '/api/system/sysNotice/querySysNoticeList',
    method: 'post',
    data: query
  });
}

export function getSysNotice(query) {
  return request({
    url: '/api/system/sysNotice/getSysNotice',
    method: 'post',
    data: query
  });
}



// WEBPACK FOOTER //
// ./src/api/notice/index.js